import {useReducer, useEffect} from 'react';
import {shallowEqualObjects} from 'shallow-equal';

function reducer(oldState, newState) {
  if (typeof newState === 'function') {
    newState = newState(oldState);
    if (newState === null) {
      return oldState;
    }
  }
  Object.keys(newState).forEach(
    key => {
      if (!Object.prototype.hasOwnProperty.call(oldState, key)) {
        console.error(`There is no key '${key}' in the oldState`); // eslint-disable-line no-console
      }
    },
  );
  if (shallowEqualObjects(oldState, newState)) {
    return oldState;
  }
  return {...oldState, ...newState};
}

export default function useStateReducer(iState, deps = []) {
  const [state, setState] = useReducer(reducer, iState);
  useEffect(() => {
    if (deps.length > 0) {
      setState(iState);
    }
  }, deps);
  return [state, setState];
}
